import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useLocation, useNavigate } from "react-router-dom";
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";

const CheckoutForm = (props) => {
  const [{ options, isRejected }, dispatch] = usePayPalScriptReducer();
  const location = useLocation();
  const navigate = useNavigate();
  const { onlinePaymentKeys } = props;

  // console.log("isRejected :- ", isRejected);
  if (isRejected) {
    dispatch({
      type: "resetOptions",
      value: {
        ...options,
        locale: "en_US", // Fallback locale
      },
    });
    dispatch({ type: "setLoadingStatus", value: "pending" });
  }

  const onApproveOrder = (data, actions) => {
    // console.log("approve data :- ", data);
    // console.log("approve actions :- ", actions);

    let param = location.search;
    navigate(`/paypal_callback/${onlinePaymentKeys.id}${param}`, {
      state: { transactionid: onlinePaymentKeys.id },
    });
  };

  return (
    <>
      <div id="paypal-payment-form" className="paypal-payment-form">
        <PayPalButtons
          id="paypal-payment-element"
          style={{ layout: "vertical", label: "pay", tagline: false }}
          createOrder={() => onlinePaymentKeys.id} // Use the manually created orderID
          onApprove={(data, actions) => onApproveOrder(data, actions)}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  session: state.session,
  eventData: state.eventData,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutForm);
